function mergeTranslation(original, translated) {
  if (translated == null || typeof translated !== "object") {
    return translated == null || translated === "" ? original : translated;
  }
  if (Array.isArray(translated)) {
    const originalList = Array.isArray(original) ? original : [];
    return originalList.map((item, index) =>
      translated[index] == null
        ? item
        : mergeTranslation(item, translated[index])
    );
  }
  const result = original && typeof original === "object" ? { ...original } : {};
  Object.entries(translated).forEach(([key, value]) => {
    if (key === "_meta") return;
    result[key] = mergeTranslation(result[key], value);
  });
  return result;
}

export function localizeEvent(event, language) {
  if (!event || language === "pt") return event;
  const translated = event?.translations?.[language];
  return translated && typeof translated === "object"
    ? mergeTranslation(event, translated)
    : event;
}
